import { Link } from "react-router-dom";
import { translate } from "@/config/translator";
import { NavbarElement } from "./navbarDesktop/navbarDesktopElement";
import { CookiesAndPrivacyLinks } from "../cookiesAndPrivacyLinks/cookiesAndPrivacyLinks";
import { clsx } from "clsx/lite";
import { useNavbarDesktop } from "./navbarDesktop/useNavbarDesktop";
import {
  faBuilding,
  faCalendarClock,
  faCirclePlus,
  faFile,
  faFileArrowDown,
  faFileArrowUp,
  faGear,
  faHouse,
  faMessage,
  faStar,
  faTag,
  faUser,
  faUserTie,
  faWindow,
} from "@fortawesome/pro-regular-svg-icons";
import {
  faFileArrowDown as faFileArrowDownFilled,
  faHouse as faHouseFilled,
  faCalendarClock as faCalendarClockFilled,
  faCirclePlus as faCirclePlusFilled,
  faFileArrowUp as faFileArrowUpFilled,
  faGear as faGearFilled,
  faMessage as faMessageFilled,
  faFile as faFileFilled,
  faBuilding as faBuildingFilled,
  faUser as faUserFilled,
  faUserTie as faUserTieFilled,
  faTag as faTagFilled,
  faWindow as faWindowFilled,
  faStar as faStarFilled,
} from "@fortawesome/pro-solid-svg-icons";
import {
  faRegularUserGlobe,
  faSolidUserGlobe,
} from "@awesome.me/kit-780d7e8966/icons/kit/custom";

export function NavbarDesktop() {
  const {
    lang,
    hasAttendancesElement,
    hasPspDocumentsTab,
    hasSubmittedDocumentsTab,
    hasTemplatesAndInstructionsElement,
    hasUploadElement,
    isInBackoffice,
  } = useNavbarDesktop();

  return (
    <div
      className={clsx(
        "h-full",
        "bg-canvas-secondary",
        "gap-4",
        "tablet:flex",
        "flex-col",
        "px-4",
        "pt-8",
        "pb-4",
        "hidden",
        "overflow-y-auto",
        "w-68",
      )}
    >
      {isInBackoffice ? (
        <>
          <h2 className="text-font-secondary">
            {translate("administration", lang)}
          </h2>
          <NavbarElement
            icon={faBuilding}
            iconSelected={faBuildingFilled}
            path="/admin/mandates"
          >
            {translate("mandates", lang)}
          </NavbarElement>
          <NavbarElement
            icon={faUser}
            iconSelected={faUserFilled}
            path="/admin/users"
          >
            {translate("users", lang)}
          </NavbarElement>
          <NavbarElement
            icon={faRegularUserGlobe}
            iconSelected={faSolidUserGlobe}
            path="/admin/external-users"
          >
            {translate("externalUsers", lang)}
          </NavbarElement>
          <NavbarElement
            icon={faUserTie}
            iconSelected={faUserTieFilled}
            path="/admin/employees"
          >
            {translate("pspEmployees", lang)}
          </NavbarElement>
          <NavbarElement
            icon={faStar}
            iconSelected={faStarFilled}
            path="/admin/rights"
          >
            {translate("rights", lang)}
          </NavbarElement>

          <h2 className="text-font-secondary">
            {translate("communication", lang)}
          </h2>
          <NavbarElement
            icon={faFileArrowUp}
            iconSelected={faFileArrowUpFilled}
            path="/admin/psp-documents"
          >
            {translate("pspDocuments", lang)}
          </NavbarElement>
          <NavbarElement
            icon={faFileArrowDown}
            iconSelected={faFileArrowDownFilled}
            path="/admin/submitted-documents"
          >
            {translate("submittedDocuments", lang)}
          </NavbarElement>
          <NavbarElement
            icon={faMessage}
            iconSelected={faMessageFilled}
            path="/admin/messages"
          >
            {translate("messages", lang)}
          </NavbarElement>
        </>
      ) : (
        <>
          <NavbarElement
            icon={faHouse}
            iconSelected={faHouseFilled}
            path="/home"
          >
            {translate("home", lang)}
          </NavbarElement>
          {hasPspDocumentsTab && (
            <NavbarElement
              icon={faFileArrowDown}
              iconSelected={faFileArrowDownFilled}
              path="/psp-documents"
            >
              {translate("pspDocuments", lang)}
            </NavbarElement>
          )}
          {hasSubmittedDocumentsTab && (
            <NavbarElement
              icon={faFileArrowUp}
              iconSelected={faFileArrowUpFilled}
              path="/submitted-documents"
            >
              {translate("submittedDocuments", lang)}
            </NavbarElement>
          )}
          {hasUploadElement && (
            <NavbarElement
              icon={faCirclePlus}
              iconSelected={faCirclePlusFilled}
              path="/upload"
            >
              {translate("upload", lang)}
            </NavbarElement>
          )}
          <NavbarElement
            icon={faMessage}
            iconSelected={faMessageFilled}
            path="/messages"
          >
            {translate("messages", lang)}
          </NavbarElement>
          {hasAttendancesElement && (
            <NavbarElement
              icon={faCalendarClock}
              iconSelected={faCalendarClockFilled}
              path="/attendances"
            >
              {translate("attendances", lang)}
            </NavbarElement>
          )}
          <NavbarElement
            icon={faGear}
            iconSelected={faGearFilled}
            path="/settings"
          >
            {translate("settings", lang)}
          </NavbarElement>
          {hasTemplatesAndInstructionsElement && (
            <NavbarElement
              icon={faFile}
              iconSelected={faFileFilled}
              path="/templates-and-instructions"
            >
              {translate("templatesAndInstructions", lang)}
            </NavbarElement>
          )}
        </>
      )}

      {/* SPACING FOR BACKOFFICE */}
      {isInBackoffice && <div className="grow" />}
      <div className="mt-4 flex flex-col items-center">
        <CookiesAndPrivacyLinks />
        <Link to="/help" className="underline text-primary">
          {translate("needHelp", lang)}
        </Link>
      </div>
    </div>
  );
}
